<template>
  <div class="viewer-website">
    <div id="player" class="youtube-player" v-if="getIsYouTube"></div>
    <iframe
      class="viewer-website__website"
      :src="getUrl(src)"
      ref="iframe"
      v-else
    ></iframe>
  </div>
</template>

<script>
import { KEYS } from '@/mixins/keyHandler';
import router from '@/router';
import { queryAssembler } from '@/mixins/queryAssembler';

export default {
  mixins: [queryAssembler],
  props: {
    src: {
      type: String,
    },
    scrollPosition: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.$eventBus.$on('key-handler', (context) => {
      if (this.getIsYouTube) {
        this.handleYoutubeKeys(context);
      }
      const keysObject = [
        'code',
        'key',
        'keyCode',
        'timeStamp',
        'type',
        'bubbles',
      ];
      const eventObject = keysObject.reduce((ret, it) => {
        const res = ret;
        res[it] = context[it];
        return res;
      }, {});
      // console.log(e);
      if (this.$refs.iframe) {
        this.$refs.iframe.contentWindow.postMessage(eventObject, '*');
      }
    });
    if (this.src.includes('youtube') || this.src.includes('youtu.be')) {
      this.handleYoutubePlayer();
    }
  },
  data() {
    return {
      player: null,
      done: false,
      isPlaying: false,
    };
  },
  methods: {
    getUrl(src) {
      return this.assembleUrl(src);
    },
    handleYoutubeKeys({ key, event }) {
      switch (key) {
        case KEYS.ENTER:
          if (!this.isPlaying) {
            this.player.playVideo();
            this.isPlaying = true;
          } else {
            this.player.pauseVideo();
            this.isPlaying = false;
          }

          console.log(this.player);
          break;
        case KEYS.RIGHT:
          this.handleSeekEvent('next');
          break;
        case KEYS.LEFT:
          this.handleSeekEvent('prev');
          break;
      }
    },
    handleSeekEvent(direction) {
      const duration = this.player.getCurrentTime();
      console.log('DURATION', duration);

      switch (direction) {
        case 'next':
          this.player.seekTo(duration + 15);
          break;
        case 'prev':
          this.player.seekTo(duration - 15 > 0 ? duration - 15 : 0);
          break;
      }
    },
    onPlayerReady(context) {
      context.target.playVideo();
      this.isPlaying = true;
    },
    onStateChange(context) {
      console.log('STATE CHANGE', context);
      if (context.data === YT.PlayerState.ENDED) {
        router.go(-1);
      }
      // if (context.data == YT.PlayerState.PLAYING && !this.done) {

      // }
    },
    assignYoutubePlayer() {
      this.player = new YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: this.getYoutTubeId,
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onStateChange,
        },
      });
    },
    handleYoutubePlayer() {
      const iframeAPI = document.getElementById('yt-iframe-api');
      if (!iframeAPI) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.id = 'yt-iframe-api';
        // const firstScriptTag = document.getElementsByName('script')[0];
        // console.log(firstScriptTag);
        // firstScriptTag.parentNode.ins(tag, firstScriptTag);
        document.body.appendChild(tag);
        window.onYouTubeIframeAPIReady = () => {
          this.assignYoutubePlayer();
        };
      } else {
        this.assignYoutubePlayer();
      }
    },
  },
  beforeDestroy() {
    this.$eventBus.$off('key-handler');
  },
  computed: {
    getIsYouTube() {
      if (this.src.includes('youtube')) return true;
      return false;
    },
    getYoutTubeId() {
      if (!this.getIsYouTube) return '';
      const arr = this.src.split('/');
      const id = arr[arr.length - 1].split('?')[0];
      return id;
    },
  },
};
</script>

<style scoped>
.viewer-website {
  height: 100vh;
  position: relative;
  width: 100vw;
}
.viewer-website__website {
  border: 0;
  height: 100%;
  position: absolute;
  /* pointer-events: none; */
  top: 0;
  transition: all 0.3s ease;
  width: 100%;
}

.youtube-player {
  height: 100vh;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/WebViewer.vue